module.exports = __webpack_public_path__ + "img/f32.5d35f82c.png";